import React, {useState} from "react";
import {
  Form,
  FormGroup,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Spinner,
  Button
} from "reactstrap";
import PropTypes from "prop-types";

import ModalPhone from "../../Modal/ModalPhone";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalError from "../../Modal/ModalError";

const Phones = ({
  phones,
  person,
  phoneTypes,
  setPersonData,
  services,
  role, 
  onboarding,
  Link,
  userSession
}) => {
  const [modalNewPhone, setModalNewPhone] = useState({
    open: false,
    loading: false,
    initial: undefined,
    error: undefined,
    messageShow: false,
    message: ""
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false
  });
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });

  const toggleModalError = (e, message) => {
    setModalError({
      open: !modalError.open,
      message,
    });
  };

  const handleSaveNewDocument = newPhone => {
    setModalNewPhone({
      ...modalNewPhone,
      loading: true,
      messageShow: false
    });
    const body = {
      person: {
        PersonId: person.PersonId,
        Phone: [
          {
            PhoneId: newPhone.PhoneId,
            PhoneType: newPhone.PhoneType,
            PhoneNumber: newPhone.PhoneNumber
          }
        ]
      },
      delete: false
    };
    if (onboarding){
      let docs = person.Phone
      let id = Number(phones.length) + 2
      if (newPhone.PhoneId > 0){
        id = newPhone.PhoneId
        docs.forEach((p, i) => {
          if (p.PhoneId == newPhone.PhoneId) {
            docs.splice(i, 1);
          }
        });
      }
      const nPhone = 
        {
          PhoneId: id,
          PhoneType: newPhone.PhoneType,
          PhoneNumber: newPhone.PhoneNumber
        }
      
    docs.push(nPhone)
    const postPerson = {
      ...person,
        Phone: docs,
    };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, response => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalNewPhone({
            ...modalNewPhone,
            open: false,
            callback: undefined,
            loading: false,
            messageShow: true,
            message: ''
          });
        } else {
          alert("Server Error");
        }
    
      });

    }else{
    services.fetchAppendPersonNewPhone(body, response => {
      if (response && response.result && response.result.Code === 200) {
        const newPerson = {...person};
        var mes = "";
        if (role == "Compliance") {
          let docs = person.Phone
          let id = Number(phones.length) + 2
          if (newPhone.PhoneId > 0){
            id = newPhone.PhoneId
            docs.forEach((p, i) => {
              if (p.PhoneId == newPhone.PhoneId) {
                docs.splice(i, 1);
              }
            });
          }
          const nPhone = 
            {
              PhoneId: id,
              PhoneType: newPhone.PhoneType,
              PhoneNumber: newPhone.PhoneNumber
            }
          
        docs.push(nPhone)
        }
        setModalNewPhone({
          ...modalNewPhone,
          open: false,
          callback: undefined,
          loading: false,
          messageShow: true,
          message: mes
        });
        setPersonData({
          newPerson,
          description: "PHONE"
        });
      } else {
        toggleModalError(
          {},
          response && response.result
            ? `Error saving Phone: ${response.result.Description}`
            : "Server Error"
        );
        setModalNewPhone({
          loading: false,
          open: false,
          messageShow: false
        });
      }
    });
  }
  };

  const handleDeleteFile = newPhone => {
    setModalNewPhone({
      ...modalNewPhone,
      loading: true,
      messageShow: false
    });
    const body = {
      person: {
        PersonId: person.PersonId,
        Phone: [
          {
            PhoneId: newPhone.PhoneId,
            PhoneType: newPhone.PhoneType,
            PhoneNumber: newPhone.PhoneNumber
          }
        ]
      },
      delete: true
    };
    if (onboarding){
      let docs = person.Phone
      if (newPhone.PhoneId > 0){
        docs.forEach((p, i) => {
          if (p.PhoneId == newPhone.PhoneId) {
            docs.splice(i, 1);
          }
        });
      }
      const postPerson = {
        ...person,
          Phone: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, response => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false
          });
          setModalNewPhone({
            ...modalNewPhone,
            loading: false,
            messageShow: false
          });
        } else {
          alert("Server Error");
        }
    
      });

    }else{
    services.fetchAppendPersonNewPhone(body, response => {
      if (response && response.result && response.result.Code === 200) {
        const newPerson = {...person};
        newPerson.Phone.forEach((p, i) => {
          if (p.PhoneId == newPhone.PhoneId) {
            newPerson.Phone.splice(i, 1);
          }
        });
        setModalConfirm({
          open: false,
          title: "",
          callback: undefined,
          loading: false
        });
        setModalNewPhone({
          ...modalNewPhone,
          loading: false,
          messageShow: false
        });
        setPersonData({
          newPerson: newPerson,
          description: "PHONE"
        });
      } else {
        toggleModalError(
          {},
          response && response.result
            ? `Error saving Phone: ${response.result.Description}`
            : "Server Error"
        );
        setModalConfirm({
          open: false,
          title: "",
          callback: undefined,
          loading: false
        });
      }
    });
  }
  };

  const toggleModalConfirm = m =>
    setModalConfirm(mod => {
      const newM = {
        ...mod,
        open: !mod.open
      };
      if (m) {
        newM.title = "Are you sure you want to remove the selected Phone?";
        newM.callback = () => handleDeleteFile(m);
      }
      return newM;
    });

  const handleToggleModalNewDocument = initial =>
    setModalNewPhone(m => ({
      open: !m.open,
      loading: m.loading,
      initial,
      error: undefined,
      message: "",
      messageShow: false
    }));

  if (!phones) {
    return <Spinner />;
  }
  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {phones.map((d, i) => (
              <ListGroupItem key={i}>
                <Row style={{fontSize: "15px", fontWeight: 500}}>
                  <Col>Type: </Col>
                  <Col>{d.PhoneType}</Col>
                  <Col>
                    {userSession.IsReadOnly === false && <div
                      style={{cursor: "pointer", float: "right"}}
                      onClick={() => handleToggleModalNewDocument(d)}
                    >
                      <i className="fa fa-edit" />
                    </div>}
                  </Col>
                </Row>
                <Row style={{fontSize: "15px", fontWeight: 500}}>
                  <Col>Phone Number: </Col>
                  <Col>{d.PhoneNumber}</Col>
                  <Col>
                    {userSession.IsReadOnly === false && <div
                      style={{cursor: "pointer", float: "right"}}
                      onClick={() => toggleModalConfirm(d)}
                    >
                      <i className="fa fa-trash" />
                    </div>}
                  </Col>
                </Row>
              </ListGroupItem>
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
      {modalNewPhone.open && (
        <ModalPhone
          {...modalNewPhone}
          onSave={handleSaveNewDocument}
          phoneTypes={phoneTypes}
          onToggle={handleToggleModalNewDocument}
          services={services}
        />
      )}
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        saving={modalConfirm.loading}
        callback={modalConfirm.callback}
        title={modalConfirm.title}
      />
      <ModalError {...modalError} onToggle={toggleModalError} />
      {userSession.IsReadOnly === false && <Button
        onClick={() => handleToggleModalNewDocument()}
        color="primary"
        style={{marginRight: 10}}
      >
        Add New Phone
      </Button>}
      <Row style={{textAlign: "right"}}> 
     </Row>
      
    </div>
  );
};

Phones.propTypes = {
  phones: PropTypes.array,
  person: PropTypes.object.isRequired,
  phoneTypes: PropTypes.array,
  setPersonData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired
};

Phones.defaultProps = {
  phones: undefined,
  phoneTypes: undefined
};

export default Phones;
